module.exports = __webpack_public_path__ + "static/media/top_arrow_menu_header.9c6c0f6f.svg";